/**
 * Identificadores de pantallas (sincronizado con catálogo del back).
 */
export enum ScreenEnum {
  Home = 'Home',
  EmailTemplates = 'EmailTemplates',
  UserType = 'UserType',
  Profiles = 'Profiles',
  Users = 'Users',
  Modules = 'Modules',
  Submodules = 'Submodules',
  Screens = 'Screens',
  Parameters = 'Parameters',
}
